/* Copyright (c) 2021-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { dateFormat } from "~/constants";
import { DateRange } from "~/types";

// This is a workaround for a problem with date input from keyboard, we cannot dynamically parse incomplete input date because it will be constantly reset to the full year
// E.g. User starts typing "12/12/1", the incomplete 0001-12-12 date will be parsed into `1901-12-12` ISO format, making it impossible to enter desired year
export function useDateValues(range?: DateRange) {
  const [startDate, setStartDate] = useState(formatShortDate(range?.startDate));
  const [endDate, setEndDate] = useState(formatShortDate(range?.endDate));

  useEffect(() => {
    setStartDate(formatShortDate(range?.startDate));
  }, [range?.startDate]);

  useEffect(() => {
    setEndDate(formatShortDate(range?.endDate));
  }, [range?.endDate]);

  return { startDate, setStartDate, endDate, setEndDate };
}

export function formatShortDate(date?: string) {
  if (date) {
    return dayjs(date).format(dateFormat.shortDate);
  }
}
